/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;

      const submitBtn = document.querySelector( '.products__filter__submit' );
      const form = document.querySelector( '#product-filter' );

      form.addEventListener( 'submit', ( e ) => {
        e.preventDefault();

        const formData = new FormData( e.target );

        const urlQuery = new URLSearchParams( formData ).toString();
        history.replaceState( '', '', '?'+decodeURIComponent( urlQuery ) );

        filterProducts( urlQuery );
        // filterTerms( urlQuery );

        if ( e.submitter.classList.contains( 'filter__pills' ) ) {
          e.submitter.remove();
        }

        handlePills();
      } );

      form.addEventListener( 'reset', ( e ) => {
        e.preventDefault();

        form.querySelectorAll( 'input[type="checkbox"]' ).forEach( ( el ) => {
          el.checked = false;
        } );

        form.querySelectorAll( '.filter__pills' ).forEach( ( el ) => {
          el.remove();
        } );

        submitBtn.click();
      } );

      handlePills();

      if ( window.location.search ) {
        filterProducts( new URLSearchParams( window.location.search ).toString() );
        handlePills();
      }

      document.body.addEventListener( 'click', function( event ) {
        const target = event.target;
        if ( target.classList.contains( 'page-numbers', 'nav-btn' ) ) {
          const page = target;
          const formData = new FormData( form );
          const urlQuery = new URLSearchParams( formData );
          urlQuery.set( 'page', page.dataset.value );
          history.replaceState( '', '', '?'+decodeURIComponent( urlQuery.toString() ) );
          filterProducts( urlQuery.toString() );
          location.href = '#grid-top'; // pagination navigation only
        }

        if ( target.classList.contains( 'filter__pills' ) ) {
          const el = target;
          const uncheckedInput = document.querySelector( 'input[name="'+el.name+'[]"][value="'+el.value+'"]' );
          uncheckedInput.checked = false;
        }
      } );

      document.querySelectorAll( 'input[type="checkbox"]' ).forEach( ( el ) => {
        el.addEventListener( 'change', () => {
          // check to see if changed checkbox has a pill if it does click the pill to remove the item, if it doesn't create the pill and then submit the form
          const currentButton = document.querySelector( 'button[value="'+el.value+'"]' );

          if ( currentButton ) {
            currentButton.click();
          } else {
            const label = document.querySelector( '[for="' +el.id+'"]' );
            const newContent = `<button type="submit" class="inline-flex items-center px-4 py-2 mx-2 mb-3 text-sm font-normal rounded-full border bg-brand-light-blue border-brand-blue text-brand-blue filter__pills" name="${el.name.replace( '[]', '' )}" value="${el.value}">
            ${label.textContent}
            <svg class="ml-3 w-3 h-3 pointer-events-none icon icon-close"><use xlink:href="#icon-close"></use></svg>
            </button>`;
            document.querySelector( '.product__filter__pills' ).insertAdjacentHTML( 'beforeend', newContent );

            submitBtn.click();
          }
        } );
      } );

      function handlePills() {
        const pillsContainer = document.querySelector( '.product__filter__pills' );
        if ( pillsContainer.childElementCount > 1 ) {
          $( pillsContainer ).slideDown();
        } else if ( pillsContainer.childElementCount < 2 ) {
          $( pillsContainer ).slideUp();
        }
      }

      function filterProducts( query ) {
        $.ajax( {
          type: 'GET',
          url: site_info.wpApiSettings.ll + 'product/filter',
          data: query,
          beforeSend: function( xhr ) {
            xhr.setRequestHeader( 'X-WP-Nonce', site_info.wpApiSettings.nonce );
            xhr.setRequestHeader( 'X-Requested-With', 'XMLHttpRequest' );
            doingAjax = true;
          },
          success: function( data ) {
            if ( data.grid ) {
              document.querySelector( '.products__grid' ).innerHTML = data.grid;
              app.components['product-card'].init();
              if ( data.paging ) {
                document.querySelector( '.ajax-pagination' ).outerHTML = data.paging;
              } else {
                document.querySelector( '.ajax-pagination' ).innerHTML = data.paging;
              }

              if ( data.count ) {
                document.querySelector( '.filter-result-count' ).outerHTML = data.count;
              }
            } else {
              document.querySelector( '.products__grid' ).innerHTML = '<p class="ll-filter-result-notice">No products found, please adjust your search</p>';
              document.querySelector( '.ajax-pagination' ).innerHTML = '';
            }
          },
          error: function( data ) {
            console.log( data );
          },
          complete: function( jqXHR, status ) {
            doingAjax = false;
          },
        } );
      }
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'products', COMPONENT );
} )( app );
